<template>
    <div>
    <div>

      <div class="grid grid-cols-6 gap-6">
        <div class="col-span-6 border-gray-200 lg:pr-6 lg:border-r lg:col-span-2">
          <form v-on:submit.prevent="onSubmit">
          <div class="flex justify-between">
            <h3 class="text-lg font-medium leading-6 text-gray-900">Raccolta email</h3>
                    <span 
                    @click="toogle()"
                    :class="this.form.enable ? 'bg-indigo-600' : 'bg-gray-200'"
                    role="checkbox" 
                    tabindex="0" 
                    aria-checked="false" 
                    class="relative flex-shrink-0 inline-block h-6 transition-colors duration-200 ease-in-out bg-gray-200 border-2 border-transparent rounded-full cursor-pointer w-11 focus:outline-none focus:shadow-outline">
                      <!-- On: "translate-x-5", Off: "translate-x-0" -->
                      <span aria-hidden="true"  :class="this.form.enable ? 'translate-x-5' : 'translate-x-0'" class="inline-block w-5 h-5 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded-full shadow"></span>
                    </span>
                </div>
                <p class="w-64 max-w-full mt-1 text-sm leading-5 text-gray-500">       Abilitando questa funzione chiederai ai tuoi clienti di lasciare un indirizzo email per poterli ricontattare in un secondo momento
                </p>

              <div v-if="form.enable">
                <div class="flex justify-between mt-4" >
                  <h3 class="text-base font-medium leading-6 text-gray-900 ">Crea coupon</h3>
                    <span 
                    @click="toogleCoupon()"
                    :class="this.form.coupon_enable ? 'bg-indigo-600' : 'bg-gray-200'"
                    role="checkbox" 
                    tabindex="0" 
                    aria-checked="false" 
                    class="relative flex-shrink-0 inline-block h-6 transition-colors duration-200 ease-in-out bg-gray-200 border-2 border-transparent rounded-full cursor-pointer w-11 focus:outline-none focus:shadow-outline">
                      <!-- On: "translate-x-5", Off: "translate-x-0" -->
                      <span aria-hidden="true"  :class="this.form.coupon_enable ? 'translate-x-5' : 'translate-x-0'" class="inline-block w-5 h-5 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded-full shadow"></span>
                    </span>
                </div>
                <p class="w-64 max-w-full mt-1 text-sm leading-5 text-gray-500">
                  Il cliente, dopo aver lasciato la sua email, riceverà un codice coupon del valore da te definito
                </p>
              </div>

                <div v-if="this.form.enable && this.form.coupon_enable" class="mt-4">
                  <div>
                    <label for="price" class="block text-sm font-medium leading-5 text-gray-700">Valore coupon <span class="font-normal">(usare il punto per i decimali)</span>
                    </label>
                    <div class="relative mt-1 rounded-md shadow-sm">
                      <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <span class="text-gray-500 sm:text-sm sm:leading-5">
                          €
                        </span>
                      </div>
                      <input v-model="form.coupon_value" id="price" class="block w-full pr-12 form-input pl-7 sm:text-sm sm:leading-5" placeholder="0.00" aria-describedby="price-currency" />
                    </div>
                    <p class="mt-1 text-xs text-red-600" v-if="formErrors.coupon_value">
                      {{ formErrors.coupon_value[0]}}
                    </p>
                  </div>
                  <div class="mt-4">
                    <label for="exipred_days" class="block text-sm font-medium leading-5 text-gray-700">Durata coupon 
                    </label>
                    <div class="relative mt-1 rounded-md shadow-sm">
                      <input v-model="form.exipred_days" id="exipred_days" class="block w-full pr-12 form-input sm:text-sm sm:leading-5" aria-describedby="price-currency" />
                       <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <span class="text-gray-500 sm:text-sm sm:leading-5">
                          giorni
                        </span>
                      </div>
                    </div>
                    <p class="mt-1 text-xs text-red-600" v-if="formErrors.exipred_days">
                      {{ formErrors.exipred_days[0]}}
                    </p>
                  </div>
                </div>
          <button
          v-if="this.form.enable && this.form.coupon_enable"
                  type="submit"
                  class="inline-flex justify-center px-4 py-2 mt-8 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700"
                >Salva</button>
                </form>
          </div>
                
                <div class="col-span-6 lg:col-span-4">

                  <div class="flex flex-col">
                    <div class="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                      <div class="inline-block min-w-full overflow-hidden align-middle border-b border-gray-200 shadow sm:rounded-lg">
                        <table class="min-w-full">
                          <thead>
                            <tr>
                              <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                Email
                              </th>
                              <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                Coupon
                              </th>
                              <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                Data
                              </th>
                            </tr>
                          </thead>
                          <tbody class="bg-white">
                            <tr v-for="email in emails" :key="email.id">
                              <td class="px-6 py-4 text-sm font-medium leading-5 text-gray-900 whitespace-no-wrap border-b border-gray-200">
                                <a :href="'mailto:'+email.email">{{email.email}}</a>
                              </td>
                              <td class="px-6 py-4 text-sm leading-5 text-gray-500 whitespace-no-wrap border-b border-gray-200">
                                {{email.coupon}}
                              </td>
                              <td class="px-6 py-4 text-sm leading-5 text-gray-500 whitespace-no-wrap border-b border-gray-200">
                                {{email.created_at}}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
      
      </div></div>
    </div>
        <modal v-show="modal.show" :event="modal.event" :icon="modal.icon" :buttonText="modal.buttonText" :buttonClass="modal.buttonClass" :eventclose="modal.eventclose" :title="modal.title" :description="modal.description"></modal>

  </div>
</template>

<script>
import MarketingEmail from "../apis/MarketingEmail";
import Modal from "../components/Modal";

export default {
  components: {
    Modal
  },
  data() {
    return {
      id: this.$route.params.id,
      tl:{},
      fields:["privacy_policy"],
      formErrors: {},
      form:{
        enable: false,
        coupon_enable: false
      },
      emails: [],
      modal:{
        type: "",
        show: false,
        title: "",
        description: "",
        event: "",
        eventclose: "",
        icon: "",
        buttonText: "",
        buttonClass: "",
      },
    };
  },
  mounted() {
    MarketingEmail.get(this.id).then(response => {
      this.form = response.data.data;
    });

    MarketingEmail.getEmails(this.id).then(response => {
      this.emails = response.data.data;
    });
  },
  created(){
  },
  methods: {
    toogle(){
      this.form.enable = !this.form.enable;
      this.form.coupon_enable = false;
      this.onSubmit();
    },
    toogleCoupon(){
      this.form.coupon_enable = !this.form.coupon_enable;
      this.onSubmit();
    },
    prepareData: function() {
      this.tl.enable = this.form.enable;
      this.tl.coupon_enable = this.form.coupon_enable;
      this.tl.coupon_value = this.form.coupon_value;
      this.tl.exipred_days = this.form.exipred_days;
    },
 

    onSubmit: function() {
      this.removeValidationErrors();
 
        this.$store.dispatch("updateSpinner", true);
        this.prepareData();
        MarketingEmail.update(this.id, this.tl)
          .then(() => {
            this.$store.dispatch("updateSpinner", false);
            this.$store.dispatch("addNotification", {id: Math.floor(Math.random() * 100000), title : "Dati aggiornati", description:""});
        })
        .catch(error => {
          if (error.response.status === 422) {
              if (error.response.data.errors.privacy_policy){

                this.$root.$on('clickGoToPP' + this.id, () => {
                    this.$router.push({ name: "MarketingPrivacyPolicy"}).catch(()=>{});
                });

                this.$root.$on('clickCloseModalGoToPP' + this.id, () => {
                  this.modal.show = false;
                });


                this.modal.event = 'clickGoToPP' + this.id;
                this.modal.eventclose = 'clickCloseModalGoToPP' + this.id;
                this.modal.title = "Attenzione";
                this.modal.description = "Per attivare questa funzione è necessario specificare la privacy policy per ciascuna lingua abilitata nel menu";
                this.modal.icon = "alert";
                this.modal.buttonText = "Inserisci Privacy Policy";
                this.modal.buttonClass = "bg-green-400 hover:bg-green-500  focus:border-green-400 focus:shadow-outline-green";
                this.modal.show = true;

                this.form.enable = false;

              }

              this.showValidationErrors(error.response.data.errors);
              this.$store.dispatch("addNotification", {id: Math.floor(Math.random() * 100000), title : "Correggi gli errori", description: "", succes: false});
          }
          this.$store.dispatch("updateSpinner", false);
        });
       
    },

    removeValidationErrors: function(){
      this.formErrors = {};
    },

    showValidationErrors: function(list){
      let keys = Object.keys(list);
      for (let i = 0; i < keys.length; i++) {
        //Errori multilingua conengono il punto
        if (keys[i].includes(".")){
          for (let j = 0; j < this.form.checked_languages.length; j++) {
            let code = this.form.checked_languages[j].code;
            for (let k = 0; k < this.fields.length; k++) {
              if (keys[i] == this.fields[k] + "Translation." + code) {
                this.tl[this.fields[k] + 'TranslationErrors'][code] = list[keys[i]][0];
              }
            }
          }
        }
      }
      this.formErrors = list;
    },
  }
};
</script>
